import React from 'react';
import classNames from 'classnames';
/**
 * Bronson ProductInfo component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-product-info.html
 * @constructor
 */
export function ProductInfo({ caption, children, className, media, title, titleLevel = 3, titleSuffix, titleTagline, testId, ...otherProps }) {
    const divClassNameList = classNames('c-product-info', className).trim();
    function renderIfTitle() {
        const HeadingElement = `h${titleLevel}`;
        if (title) {
            return (React.createElement("hgroup", { className: "c-product-info__header" },
                React.createElement(HeadingElement, { className: "c-product-info__title" },
                    title,
                    titleSuffix && React.createElement("span", { className: "u-heading-alternative" }, titleSuffix)),
                titleTagline && React.createElement("p", { className: "c-product-info__subtitle" }, titleTagline)));
        }
        return null;
    }
    function renderIfMediaElement() {
        if (media) {
            /**
             * Check if the media element is an image and assign a proper class to it
             */
            if (media.type === 'img') {
                return React.cloneElement(media, {
                    ...media.props,
                    ...{
                        className: classNames('c-product-info__image', media?.props?.className),
                    },
                });
            }
            return media;
        }
        return null;
    }
    function renderIfCaption() {
        if (caption) {
            return React.createElement("figcaption", { className: "c-product-info__caption" }, caption);
        }
        return null;
    }
    function renderIfMedia() {
        if (media) {
            return (React.createElement("div", { className: "c-product-info__media" },
                React.createElement("figure", { className: "c-product-info__figure", role: "group" },
                    renderIfMediaElement(),
                    renderIfCaption())));
        }
        return null;
    }
    return (React.createElement("div", { ...otherProps, "data-testid": testId, className: divClassNameList },
        renderIfTitle(),
        renderIfMedia(),
        React.createElement("div", { className: "c-product-info__aside" }, children)));
}
